import React from 'react';
import PropTypes from 'prop-types';
import Isvg from 'react-inlinesvg';

import { intlMessage, requiredRule } from 'constants/propTypes';
import { bem } from 'helpers/class-name';
import Message from 'components/Message';
import { TooltipToggle, TooltipContent } from 'components/Tooltip';
import When from 'components/When';
import { ICONS } from 'constants/icons';

import messages from '../messages';
import './Label.scss';

const { block, element } = bem('hook-form-label');

function Label(props) {
  const { message, optional, required, showRequiredLabel, name = '', className = '', children, tooltip } = props;

  if (!message && !children && !optional && !showRequiredLabel) return null;

  let metaMessage;
  if (required && showRequiredLabel) {
    metaMessage = messages.meta.required;
  } else if (optional) {
    metaMessage = messages.meta.optional;
  }

  return (
    <label className={block(className)} htmlFor={name}>
      {message && <Message message={message} />}
      <When predicate={!!tooltip}>
        <TooltipToggle name={`tooltip-${name}`} className="ml-small">
          <Isvg className={element('tooltip-icon')} src={ICONS.infoGrey} />
        </TooltipToggle>
        <TooltipContent name={`tooltip-${name}`} hoverable>
          <Message message={tooltip} />
        </TooltipContent>
      </When>
      {children}
      {metaMessage && <Message message={metaMessage} className={element('meta')} />}
    </label>
  );
}

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  message: intlMessage,
  name: PropTypes.string,
  optional: PropTypes.bool,
  required: requiredRule,
  showRequiredLabel: PropTypes.bool,
  tooltip: intlMessage,
};

export default Label;
